import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "nav-saving-icon" }

import { computed } from "vue";
import { appStore } from "@/hooks";
import { Icon } from "@/components/common";


/**
 * Renders app saving state.
 */
const __default__ = {
  name: "SavingIcon",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const isSaving = computed(() => appStore.isSaving);

return (_ctx: any,_cache: any) => {
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (isSaving.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_circular_progress, {
            color: "secondary",
            indeterminate: "",
            size: "md"
          })
        ]),
        _createVNode(_unref(Icon), {
          color: "secondary",
          variant: "saving",
          size: "sm"
        }),
        _createVNode(_component_q_tooltip, null, {
          default: _withCtx(() => [
            _createTextVNode(" Saving... ")
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})